<template>
    <div class="d-flex align-center align-self-center" style="width: 100%">
      <v-text-field 
        :type="type" 
        :label="$t(label)"
        :disabled="readonly" 
        :value="value" 
        :prepend-icon="prependIcon"
        @input="onChangeValue"
      />
      <v-btn v-if="!readonly && value" x-small @click.stop="onChangeValue('')" icon class="mb-1">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn icon color="accent" @click.stop="onOpenDialog()">
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </div>
</template>

<script>
export default {
  props: ['value', 'readonly', 'label', 'type', 'prependIcon'], 
  methods: {
    onOpenDialog() {
      this.$emit('onOpenDialog') 
    },
    onChangeValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>